import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import { ReactComponent as ManIcon } from 'icons/components/man.svg';
import { ReactComponent as WomanIcon } from 'icons/components/woman.svg';

import './index.less';
import './themes/default.less';

export default class Avatar extends MainComponent {
    static propTypes = {
        sex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        size: PropTypes.number,
        radius: PropTypes.number,
        iconWidth: PropTypes.number,
        iconHeight: PropTypes.number,
        tempPhoto: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    };
    static defaultProps = {
        sex: "female",
        id: 0,
        size: 40,
        radius: 4,
        iconWidth: 26,
        iconHeight: 35,
        tempPhoto: false,
    };

    onImageLoaded() {
        this._helper.dom.addClass(this.domNode, "loaded");
    }

    openImage(id, e) {
        this._helper.stopEvent(e);
        this._helper.showImageBox(id);
    }

    render() {
        const { id, sex, size, radius, iconWidth, iconHeight, tempPhoto } = this.props;

        const isMen = sex?.toLowerCase ? (sex.toLowerCase() !== "female") : (sex === 0);
        const hasImg = !!id;
        let cl = isMen ? "man" : "woman";

        if (hasImg)
            cl += " hand";

        const iconProps = {
            width: iconWidth,
            height: iconHeight,
        };

        return (
            <div
                ref={el => this.domNode = el}
                className={`avatarItem pos rel icon flex centerH endV hidden ${id ? "" : cl}`}
                style={{
                    "--size": size + "px",
                    "--radius": radius + "px"
                }}
                onClick={hasImg ? this.openImage.bind(this, id) : null}
            >
                {(isMen ?
                    <ManIcon {...iconProps} /> :
                    <WomanIcon {...iconProps} />
                )}
                {(!!id || tempPhoto) && <img
                    className="pos abs sideAll"
                    src={tempPhoto ? tempPhoto : this._request.images.getAvatar(id)}
                    alt="Avatar"
                    onLoad={this.onImageLoaded.bind(this)} />}
            </div>
        );
    }
}
